import React from 'react';
export default function GoldDivider() {
  return (
    <div style={{
      width: '120px',
      height: '1px',
      background: 'linear-gradient(90deg, transparent, var(--gold), transparent)',
      margin: '1.5rem auto',
    }} />
  );
}
